<template>
  <div class="ol-actions-panel ol-actions-reminder" role="tabpanel">
    <form class="ol-actions-schedule-form" @submit.prevent>
      <div class="ol-actions-schedule-form__row">
        <div class="ol-actions-schedule-form__field">
          <label class="ol-actions-schedule-form__label">{{
            $t("lang.opportunities.new_date")
          }}</label>
          <div class="ol-actions-schedule-form__picker-wrap">
            <date-picker
              v-model="day"
              :config="configs.day"
              class="ol-actions-schedule-form__picker"
            />
          </div>
        </div>
        <div class="ol-actions-schedule-form__field">
          <label class="ol-actions-schedule-form__label">{{
            $t("lang.opportunities.new_time")
          }}</label>
          <div class="ol-actions-schedule-form__picker-wrap">
            <date-picker
              v-model="hour"
              :config="configs.hour"
              class="ol-actions-schedule-form__picker"
            />
          </div>
        </div>
      </div>

      <div class="ol-actions-schedule-form__field ol-actions-schedule-form__field--full">
        <label class="ol-actions-schedule-form__label">
          {{ $t("lang.label.comment") }}
        </label>
        <textarea
          v-model="remark"
          class="ol-actions-schedule-form__textarea"
          :placeholder="$t('lang.label.comment')"
          rows="3"
        />
      </div>
    </form>

    <div class="ol-actions-panel__footer ol-actions-panel__footer--end ol-actions-panel__footer--gap">
      <button
        type="button"
        class="ol-actions-btn ol-actions-btn--outline"
        @click="resetForm"
      >
        {{ $t("lang.button.cancel") }}
      </button>
      <button
        type="button"
        class="ol-actions-btn ol-actions-btn--primary"
        :disabled="!canSave"
        @click.once="createEvent"
      >
        {{ $t("lang.opportunities.confirm_reminder") }}
      </button>
    </div>
  </div>
</template>

<script>
import { linksService } from "@/_services";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      eventId: "2",
      day: moment().add(1, "day").format("DD-MM-YYYY"),
      hour: "9:00 AM",
      remark: "Call back",
      configs: {
        day: {
          format: "DD-MM-YYYY",
          useCurrent: false,
          minDate: moment().endOf("day"),
        },
        hour: {
          format: "LT",
          useCurrent: false,
        },
      },
    };
  },

  props: {
    linkId: String,
  },

  computed: {
    canSave() {
      return this.remark != "" && this.day != null && this.hour != null;
    },
  },

  methods: {
    ...mapActions("opportunities", {
      reloadOpportunity: "reloadOpportunity",
    }),

    resetForm() {
      this.day = moment().add(1, "day").format("DD-MM-YYYY");
      this.hour = "9:00 AM";
      this.remark = "Call back";
    },

    createEvent() {
      const eventDate = this.createEventDate(
        this.day,
        this.formatTime(this.hour)
      );
      linksService
        .createEvent(this.linkId, this.eventId, this.remark, eventDate)
        .then(() => {
          this.reloadOpportunity({ headerTab: "NOTHING" });
        });
    },

    createEventDate(day, hour) {
      var dayArray = day.split(/-|\s|:/);
      return `${dayArray[2]}-${dayArray[1]}-${dayArray[0]} ${hour}`;
    },

    formatTime(time) {
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return `${sHours}:${sMinutes}:00`;
    },
  },
};
</script>

<style scoped>
.ol-actions-panel {
  padding: 1rem 1.25rem;
}

.ol-actions-schedule-form__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;
}

.ol-actions-schedule-form__label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.ol-actions-schedule-form__picker-wrap {
  position: relative;
}

.ol-actions-schedule-form__picker >>> .input-group {
  width: 100%;
}

.ol-actions-schedule-form__picker >>> .input-group-prepend,
.ol-actions-schedule-form__picker >>> .input-group-append {
  display: none;
}

.ol-actions-schedule-form__picker >>> input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  color: #111827;
  background: white;
}

.ol-actions-schedule-form__textarea {
  width: 100%;
  min-height: 70px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  color: #111827;
  resize: vertical;
  line-height: 1.5;
  outline: none;
  box-sizing: border-box;
}

.ol-actions-panel__footer {
  display: flex;
  align-items: center;
  margin-top: 14px;
}

.ol-actions-panel__footer--end {
  justify-content: flex-end;
}

.ol-actions-panel__footer--gap {
  gap: 8px;
}

.ol-actions-btn {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 14px;
  line-height: 1.2;
}

.ol-actions-btn--primary {
  background: #4b4be1;
  color: white;
  border: none;
}

.ol-actions-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ol-actions-btn--outline {
  background: white;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

@media (max-width: 576px) {
  .ol-actions-schedule-form__row {
    grid-template-columns: 1fr;
  }
}
</style>
